import styled from 'styled-components'

export const HomeBody = styled.main`
  padding: 1vh 0;
  @media (min-width: 1024px) {
    display: flex;
    align-items: flex-start;
    gap: 20px;
  }
`
